interface IWujieProps {
  /**主应用标识 */
  sourceApp?: string
  /**AI 管理后台免密身份 */
  manageIdentity?: string
  /**AI 管理后台免密登录 token */
  accessToken?: string
  /**是否显示侧边栏 */
  sidebar?: boolean
  /**是否显示状态栏 */
  statusbar?: boolean
  /**是否显示公告栏 */
  noticebar?: boolean
  /**主应用关闭回调 */
  onClose?: () => void
  /**子应用路由变化回调 */
  onRouteChange?: (route: {
    path: string
    fullPath: string
    name?: string
    query: Record<string, unknown>
    params: Record<string, unknown>
  }) => void
}

interface IWujie {
  /**是否被作为子应用使用 */
  __POWERED_BY_WUJIE__?: boolean
  /**是否从 AI 管理后台主应用打开 */
  isFromAiAdmin: boolean
  /**是否从详情预览中心主应用打开 */
  isFromDetailPreviewHub: boolean
  /**无界的实例（所有方法都在上面） */
  wujie: any
  /**无界传递过来的 prop */
  props: IWujieProps
  /**AI 管理后台免密身份请求头 */
  getAiAdminIdentityHeaders: () => Record<string, string | undefined>
  /**AI 管理后台详情页返回目标 */
  getAiAdminBackRouteName: (isDraftPage: boolean) => 'Draft' | 'Send'
}

export const WUJIE_SOURCE_APP = {
  AI_ADMIN: 'storybrooke-ai-admin-web',
  DETAIL_PREVIEW_HUB: 'proxy-manifest-customer-confirm',
} as const

const wujie = window?.$wujie || {}
const props = (window?.$wujie?.props || {}) as IWujieProps
const __POWERED_BY_WUJIE__ = window.__POWERED_BY_WUJIE__
const isFromAiAdmin =
  Boolean(__POWERED_BY_WUJIE__) && props.sourceApp === WUJIE_SOURCE_APP.AI_ADMIN
const isFromDetailPreviewHub =
  Boolean(__POWERED_BY_WUJIE__) &&
  props.sourceApp === WUJIE_SOURCE_APP.DETAIL_PREVIEW_HUB

const getAiAdminIdentityHeaders = () => ({
  'manage-identity': props.manageIdentity,
  'access-token': props.accessToken,
})
const getAiAdminBackRouteName = (isDraftPage: boolean) =>
  isDraftPage ? 'Draft' : 'Send'

export const useWujie = (): IWujie => {
  return {
    __POWERED_BY_WUJIE__,
    isFromAiAdmin,
    isFromDetailPreviewHub,
    wujie,
    props,
    getAiAdminIdentityHeaders,
    getAiAdminBackRouteName,
  }
}
